import AddressModel from './AddressModel';
import S3PhotoModel from './S3PhotoModel';
import UserModel from './UserModel';
import LocationModel from './LocationModel';
import SchoolModel from './SchoolModel';
import moment from 'moment';

export default class CounselorProfileModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.office_address = data.office_address ? new AddressModel(data.office_address) : null;
    this.office_phone = data.office_phone || '';

    this.user = data.user ? new UserModel(data.user) : null;

    this.school = data.school ? new SchoolModel(data.school) : null;

    this.has_set_working_hours = data.has_set_working_hours || false
    this.counseling_certificate = data.counseling_certificate ? new S3PhotoModel(data.counseling_certificate) : null;
    this.government_id = data.government_id ? new S3PhotoModel(data.government_id) : null;
    this.malpractice_insurance = data.malpractice_insurance ? new S3PhotoModel(data.malpractice_insurance) : null;

    this.completed_profile = data.completed_profile || false;
    this.lgbtq = data.lgbtq;
    this.religion = data.religion;
    this.languages = data.languages || [];
    this.calendar_initialized = data.calendar_initialized || false;

    this.on_campus_counselor = data.on_campus_counselor || false;

    this.biography = data.biography || '';
    // this.accepted_insurance = data.accepted_insurance || '';

    this.registered_in_states = (data.registered_in_states || []).map(s => new LocationModel(s));
    this.accepted_insurance_carriers = (data.accepted_insurance_carriers || []).map(s => new LocationModel(s));
    this.specialties = (data.specialties || []).map(s => new LocationModel(s));

    this.next_availability = data.next_availability ? moment(data.next_availability).toDate() : null;

    this.third_party_calendar_initialized = data.third_party_calendar_initialized || '';
    this.in_app_calendar_initialized = data.in_app_calendar_initialized || '';

    this.cost = data.session_price || data.price || data.cost || 0;

    this.verified = data.verified;

    // added in for admin users
    this._email = data.email || '';

    // set in admin before view
    this.adminModel = null;
  }

  get _is_active() {
    return this.adminModel && this.adminModel.isActive;
  }

  get hasFile() {
    return !!(this.counseling_certificate || this.malpractice_insurance || this.government_id);
  }

  get email() {
    if (this.adminModel) {
      return this.adminModel.email;
    }

    return this._email || (this.user ? this.user.email : '');
  }

  get _photo() {
    return this.user && this.user.photo;
  }

  get fullName() {
    return this.name;
  }

  get name() {
    return this.user && this.user.fullName;
  }

  get schoolName() {
    return (this.school && this.school.name) || '';
  }

  get isVerified() {
    if (this.adminModel) {
      return this.adminModel.verified;
    }
    return this.verified;
  }

  get statusDisplay() {
    if (this.isVerified) {
      return 'VERIFIED';
    } else if (this.isVerified === null) {
      return 'PENDING';
    } else {
      return 'REJECTED';
    }
  }
}
